import styled from 'styled-components';

export const Content = styled.div`
  text-align: left;

  .input-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .label {
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 100%;
      color: var(--color-text-muted);
      padding: 0 10px 0 0;
    }

    .name {
      color: var(--color-text);
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      padding: 0 0 20px;
    }

    input {
      height: 40px;
    }
  }

  .flex-row {
    margin: 0 0 20px;

    .input-wrapper,
    .switch-wrapper {
      max-width: 166px;
    }

    .form-select {
      min-width: 166px;
    }

    .input-wrapper {
      .input,
      .textarea {
        margin: 0;
      }
    }
  }

  .card,
  .rate {
    color: var(--color-text);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    padding: 0 0 20px;

    &.red {
      color: red;
    }
  }

  .description {
    color: var(--color-text-subtle);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    padding: 0 0 10px;

    p {
      padding: 0 0 2px 8px;
      margin: 0;

      &:first-child {
        padding-left: 0;
      }
    }
  }
`;
